<template>
  <div class="moral-screen-root">
    <!-- 全屏 iframe 加载纯 HTML 大屏，彻底规避 Vue scoped CSS 的所有兼容问题 -->
    <!-- HTML 大屏自己从 localStorage 读取 Token 调用 API，与 Vue 主应用完全解耦 -->
    <iframe
      ref="screenFrame"
      :src="iframeSrc"
      class="screen-iframe"
      frameborder="0"
      allowfullscreen
    ></iframe>
  </div>
</template>

<script>
import { BaseApiUrl } from '../../api/base'
import { publicAssetUrl } from '@/utils/publicAssetUrl'

export default {
  name: 'MoralEducationBigScreen',
  computed: {
    // 构造 iframe src，把后端地址和部门 ID 通过 URL 参数传入 HTML 页面
    iframeSrc() {
      // 解析路由参数中的 departmentId
      const urlParams = new URLSearchParams(window.location.search)
      let departmentId = urlParams.get('departmentId') || '99'
      if (departmentId === '0') departmentId = '99'

      // 传入后端地址（由 base.js 提供）和部门 ID
      const params = new URLSearchParams({
        apiBase: BaseApiUrl,
        departmentId,
        _v: '2026053120',
      })
      // build:api 下须带 /ui 前缀。创建于 2026-08-12
      return `${publicAssetUrl('moral-education-big-screen.html')}?${params.toString()}`
    },
  },
  mounted() {
    // 监听 iframe 发来的退出消息
    window.addEventListener('message', this.handleIframeMessage)
  },
  beforeDestroy() {
    window.removeEventListener('message', this.handleIframeMessage)
  },
  methods: {
    // 处理 iframe 发来的 postMessage
    handleIframeMessage(event) {
      if (event.data && event.data.type === 'MORAL_SCREEN_BACK') {
        // 退出大屏，返回上一页
        this.$router.go(-1)
      }
    },
  },
}
</script>

<style scoped>
/* 根容器铺满整个视口 */
.moral-screen-root {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background: #02071d;
}

/* iframe 填满整个容器，无边框无滚动条 */
.screen-iframe {
  width: 100%;
  height: 100%;
  border: none;
  display: block;
}
</style>
